export default "__VITE_PUBLIC_ASSET__0580bc4c__"